import api from "services/api";

// Get project performance report
export const getProjectPerformance = async (data) => {
  return api.post("/v1/api/reports/project-performance", data);
};
